import React from 'react';
import DocumentTitle from 'react-document-title';

import CompanyPage from '../components/company/company-page';

const CompanyRoute = () => (
  <React.Fragment>
    <DocumentTitle title="Company | NerdWallet" />
    <CompanyPage />
  </React.Fragment>
);

CompanyRoute.displayName = 'CompanyRoute';
CompanyRoute.analyticsName = 'company_page';
CompanyRoute.segmentPageName = 'company';

export default CompanyRoute;
